













import { Component, Vue } from 'vue-property-decorator';
import Sidebar from './components/Sidebar.vue';
import UploadFotos from './views/UploadFotos.vue';

@Component({
    components: {
        Sidebar,
        UploadFotos
    }
})
export default class App extends Vue {
}
